(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CouponV2Controller', CouponV2Controller);

    CouponV2Controller.$inject = ['$rootScope', '$scope', '$state', 'Coupon', 'PersonInfo', 'Customer', 'ParseLinks', 'AlertService', 'entity', 'CustomerCustom', 'CouponCustom', '$mdDialog', '$translatePartialLoader', 'ServiceItemCustom', 'CustomerGroupCustom'];

    function CouponV2Controller($rootScope, $scope, $state, Coupon, PersonInfo, Customer, ParseLinks, AlertService, entity, CustomerCustom, CouponCustom, $mdDialog, $translatePartialLoader, ServiceItemCustom, CustomerGroupCustom) {

        var vm = this;
        vm.coupon = entity;
        vm.loadAll = loadAll;
        loadAll();
        vm.save = save;
        vm.hasAllNecessaryFields = true;
        vm.columnCount = null;
        vm.allServiceItems = [];
        vm.switch_changed = switch_changed;
        vm.forAllServices = true;
        vm.forAllCustomerGroups = true;
        vm.switch_customerGroup_changed = switch_customerGroup_changed;
        vm.allCustomerGroups = [];

        vm.okModal = okModal;
        vm.closeModal = closeModal;
        vm.getModalTitle = getModalTitle;
        vm.deleteCoupon = deleteCoupon;


        initDefault();
        loadAll();

        function initDefault() {
            if (!vm.coupon.generateType)
                vm.coupon.generateType = "MANUAL";

            if (!vm.coupon.status)
                vm.coupon.status = "ACTIVE";

            if (!vm.coupon.amountType)
                vm.coupon.amountType = "PERCENT";

            $rootScope.$broadcast('hideNavBar');
        }

        function loadAll() {
            $translatePartialLoader.addPart('companyCustomer');
            $translatePartialLoader.addPart('couponGenerateTypes');
            getAllServices();
            getAllCustomerGroups();
        }

        function getAllServices() {

            ServiceItemCustom.getServiceItemsByCurrentCompany().query().$promise.then(function (result) {
                    vm.allServiceItems = result;
                    makeServicesSelectedOnLoad();
                }
            );
        }

        function getAllCustomerGroups() {

            CustomerGroupCustom.getCustomerGroupsByCurrentCompany().query().$promise.then(function (result) {
                    vm.allCustomerGroups = result;
                    makeCustomerGroupsSelectedOnLoad();
                }
            );
        }

        function save() {
            vm.isSaving = true;
            addServiceItems();
            addCustomerGroups();

            if (vm.coupon.id !== null) {
                Coupon.update(vm.coupon, onSaveSuccess, onSaveError);
            } else {

                Coupon.save(vm.coupon, onSaveSuccess, onSaveError);

            }

            function onSaveError() {
                vm.isSaving = false;
            }

            function onSaveSuccess(result) {
                $scope.$emit('tikonApp:couponUpdate', result);
                vm.isSaving = false;
                $state.go('supplierPanel-v2.editCoupon', {id: result.id});
                loadAll();
                vm.coupon.couponCode = vm.coupon.couponCode.toLowerCase();

            }

        }
        
        function switch_changed() {
            if (vm.forAllServices) {
                angular.forEach(vm.allServiceItems, function (item) {
                    item.selected = false;
                })

            } else {

            }
        }

        function switch_customerGroup_changed() {
            if (vm.forAllCustomerGroups) {
                angular.forEach(vm.allCustomerGroups, function (item) {
                    item.selected = false;
                })

            } else {

            }
        }


        function addServiceItems() {

            vm.coupon.serviceItems = [];
            angular.forEach(vm.allServiceItems, function (item) {

                if (item.selected) {
                    vm.coupon.serviceItems.push(item);
                }

            })
        }

        function addCustomerGroups() {

            vm.coupon.customerGroups = [];
            angular.forEach(vm.allCustomerGroups, function (item) {

                if (item.selected) {
                    vm.coupon.customerGroups.push(item);
                }

            })
        }

        function makeServicesSelectedOnLoad() {


            if (vm.coupon.serviceItems && vm.coupon.serviceItems.length > 0) {
                vm.forAllServices = false;


                angular.forEach(vm.coupon.serviceItems, function (item) {
                    angular.forEach(vm.allServiceItems, function (allItem) {
                        if (allItem.id == item.id)
                            allItem.selected = true;
                    })

                })

            }
        }


        function makeCustomerGroupsSelectedOnLoad() {


            if (vm.coupon.customerGroups && vm.coupon.customerGroups.length > 0) {
                vm.forAllCustomerGroups = false;


                angular.forEach(vm.coupon.customerGroups, function (item) {
                    angular.forEach(vm.allCustomerGroups, function (allItem) {
                        if (allItem.id == item.id)
                            allItem.selected = true;
                    })

                })

            }
        }

        function okModal() {
            save();

        }

        function closeModal() {
            $rootScope.$broadcast('showNavBar');
            $state.go('supplierPanel-v2.couponList');

        }

        function getModalTitle() {
            if (vm.coupon.id)
                return 'tikonApp.coupon.home.edit';
            else
                return 'tikonApp.coupon.home.new';
        }

        function deleteCoupon() {
            Coupon.delete(vm.coupon, onDeleteSuccess);
        }

        function onDeleteSuccess(res) {
            $rootScope.$broadcast('showNavBar');
            $state.go('supplierPanel-v2.couponList');
        }
    }
})();
